<div class="payment-result-container display-flex-column  fill-height position-relative"
    [ngClass]="{'flex-centered-container-hr-column':isLoading,'flex-space-between':!isLoading}">
    <ng-container *ngIf="!isLoading;else loading">
        <button mat-icon-button aria-label="close dialog" class="position-absolute close-button bg-white" tabindex="-1"
            (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
        <div class="avatar-payment-result flex-centered-container-hr">
            <img src="/assets/icons/logo-compact.png">
        </div>
        <div class="text-center margin-24-bottom">
            <!-- <div class="alert-img" *ngIf="isFailed">
                <img src="/assets/icons/alert.svg" />
            </div> -->
            <div class="flex-centered-container no-wrap">
                <mat-icon class="check-icon text-accent margin-8-right font-20"
                    *ngIf="status===TransactionStatus.SUCCESS; else paymentFailed">check_circle_filled
                </mat-icon>
                <mat-icon *ngIf="isFailed" class="text-negative margin-8-right font-20">
                    cancel_rounded
                </mat-icon>
                <ng-container *ngIf="!amount; else subscribedBlock">
                    <h3> {{ isFailed ? "Payment Failed" : "Payment Completed"}}</h3>
                </ng-container>
                <ng-template #subscribedBlock>
                    <h3>{{planName}} Plan Subscribed</h3>
                </ng-template>
            </div>
            <p class="font-14 payment-result-text" *ngIf="isFailed">Your subscription change request was unsuccessful.</p>

            <ng-container *ngIf="status===TransactionStatus.SUCCESS">
                <ng-container *ngIf="amount">
                    <div>₹{{amount}}</div>
                    <div class="font-12 pad-8-vr">has been deducted from your Broker account</div>
                </ng-container>
                <div class="dash margin-8-bottom"></div>
                <div class="font-14" *ngIf="isAdvancePayment">
                    Advance Payment received. It will be adjusted in the next billing.
                </div>
                <div class="font-14" *ngIf="!isAdvancePayment">
                    Valid till <span class="font-bold">{{validity}}</span>
                </div>
            </ng-container>

        </div>
        <div class="text-center margin-32-bot">
            <div class="pad-8-bottom" *ngIf="!isFailed">
                <a class="text-accent font-14 cursor-pointer" (click)="routeToTransactionHistory()"><span class="decoration-underline">
                        Check Transaction History</span>
                    ></a>
            </div>
            <!-- not required in pop up for any case for now -->
            <button mat-flat-button color="accent" (click)="action()" class="ut-pro-button gradient action-btn"
                [ngClass]="{'action-btn-failed':status===TransactionStatus.FAILED}" tabindex="-1" *ngIf="!amount">
                {{ isFailed ? "Try Again" :
                "Download Invoice" }}
            </button>
        </div>
    </ng-container>
    <ng-template #loading>
        <div>
            <div class="text-center payment-result-text">
                <h3>Please wait your transaction is under process</h3>
            </div>
            <div class="flex-centered-container">
                <mat-spinner class="spinner"></mat-spinner>
            </div>
        </div>
    </ng-template>
</div>
